<div class="bv-vault-filters" data-testid="filters">
  @if (!isLoaded) {
    <div class="tw-text-center tw-p-5">
      <i class="bwi bwi-spinner bwi-spin" aria-hidden="true"></i>
    </div>
  } @else {
    <div>
      <div class="bv-vault-filters__header" data-testid="filters-header">
        {{ "filters" | i18n }}
        <span class="bv-vault-filters__info" aria-hidden="true"></span>
      </div>
      <div data-testid="filters-body">
        <div class="bv-vault-filters__search bv-vault-filters__search--hidden">
          <bit-search
            id="search"
            placeholder="{{ searchPlaceholder | i18n }}"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchTextChanged($event)"
            autocomplete="off"
            appAutofocus
          />
        </div>
        @for (f of filtersList; track f) {
          <div class="filter">
            <app-filter-section
              [activeFilter]="activeFilter"
              [section]="f"
              [isCollectionFilter]="f === filters?.collectionFilter"
            >
            </app-filter-section>
          </div>
        }
      </div>
    </div>
  }
</div>
